<template>
  <Modal
    v-model="val"
    :width="800"
  >
    <div v-if="val">
      <h2 class="mb-m">個人資料告知事項</h2>
      <div
        :style="{height: '600px',overflow: 'scroll'}"
      >
        <p 
          class="mb-s fz-tiny" 
        >
          本公司（ {{insuCompany}}保險股份有限公司）依據個人資料保護法（以下稱個資法）第八條第一項(如為間接蒐集之個人資料則為第九條第一項)規定，向台端告知下列事項，敬請 台端詳閱：
        </p>
        <ul 
          :style="{listStyle: 'none', whiteSpace: 'pre-wrap'}"
        >
          <li 
            v-for="item in statement"
            :key="item.title"
            class="mb-s"
          >
            <p
              class="fz-tiny"
              v-text="item.title"
            />
            <p
              v-for="sub in item.items"
              :key="sub"
              :style="{paddingLeft: '10px'}"
              v-text="sub"
              class="fz-tiny"
            >
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div slot="footer" />
  </Modal>
</template>

<script>
  import { Modal } from 'iview';
    import { mapState } from 'vuex';
  import statement from '@/staticData/personalInfoStatement';

  export default {
    components: { Modal },
    props: {
      value: {
        type: Boolean,
        default: false
      },  
      insuCompany:
      {
        type:String,
        default:''
      }   
    },
    data() {       
      return {
        statement
      };     
    },
    computed: {      
      ...mapState({
        checkout: ({ checkout }) => checkout       
      }),
    insuCompany(){     
         const { checkout } = this;        
        let insuCompany1=this.checkout.insuInfos[0].insuCompany;       
        //console.log("this.insuCompany:"+this.checkout.insuInfos[0].insuCompany);         
        return insuCompany1;
       },
      val: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    }
  };
</script>